import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AdminService } from 'src/app/core/services/admin.service';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.css']
})
export class ImagePreviewComponent implements OnInit, OnDestroy {

  imageSubscription: Subscription;
  image: any;
  isLoading: boolean = true;
  isError: boolean = false;
  reason: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private adminService: AdminService,
    private translocoService: TranslocoService
  ) { }


  ngOnInit(): void {
    this.imageSubscription = this.adminService.getConfigurationImage(this.data).subscribe(response => {
      this.isLoading = false;
      if (response.message !== undefined) {
        this.isError = true;
        this.reason = response.message;
      } else {
        this.image = response.payload.fileData;
      }
    },
      error => {
        this.isLoading = false;
        this.isError = true;
        this.reason = this.translocoService.translate('something_wrong');
      })
  }

  ngOnDestroy(): void {
    if (this.imageSubscription) {
      this.imageSubscription.unsubscribe();
    }
  }
}
